function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1022 15.3125V16.875C14.1022 18.5982 12.7003 20 10.977 20H3.12514C1.40189 20 0 18.5982 0 16.875V3.125C0 1.40182 1.40189 0 3.12514 0H10.977C12.7003 0 14.1022 1.40182 14.1022 3.125V4.6875C14.1022 5.11902 13.7524 5.46875 13.3209 5.46875C12.8894 5.46875 12.5396 5.11902 12.5396 4.6875V3.125C12.5396 2.26349 11.8386 1.5625 10.977 1.5625H3.12514C2.26359 1.5625 1.56257 2.26349 1.56257 3.125V16.875C1.56257 17.7365 2.26359 18.4375 3.12514 18.4375H10.977C11.8386 18.4375 12.5396 17.7365 12.5396 16.875V15.3125C12.5396 14.881 12.8894 14.5312 13.3209 14.5312C13.7524 14.5312 14.1022 14.881 14.1022 15.3125ZM19.4288 8.65799L17.6793 6.90857C17.3741 6.60339 16.8794 6.60339 16.5744 6.90857C16.2692 7.21359 16.2692 7.70828 16.5744 8.01331L17.8188 9.25781H8.43787C8.00633 9.25781 7.65659 9.60754 7.65659 10.0391C7.65659 10.4706 8.00633 10.8203 8.43787 10.8203H17.8188L16.5744 12.0648C16.2692 12.3698 16.2692 12.8645 16.5744 13.1696C16.727 13.3221 16.9269 13.3984 17.1268 13.3984C17.3268 13.3984 17.5267 13.3221 17.6793 13.1696L19.4288 11.4201C20.1904 10.6586 20.1904 9.41956 19.4288 8.65799Z",
  fill: "currentColor"
});
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.60e4d8e17a5b810e526f3a7427a6713c.svg";
export { ForwardRef as ReactComponent };